interface Props {
  score: number
  size?: number
}

function scoreColor(score: number): string {
  if (score >= 80) return '#3ee07a'
  if (score >= 60) return '#1ad6c4'
  if (score >= 40) return '#ff8a5b'
  return '#ff5470'
}

function ScoreRing({ score, size = 120 }: Props) {
  const clamped = Math.max(0, Math.min(100, score))
  const stroke = size * 0.09
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (clamped / 100) * circumference
  const color = scoreColor(clamped)

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.8s ease', filter: `drop-shadow(0 0 6px ${color}88)` }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-bold leading-none" style={{ color, fontSize: size * 0.3 }}>
          {clamped}
        </span>
        <span className="text-[10px] uppercase tracking-widest mt-1" style={{ color: '#6a7682' }}>
          Score
        </span>
      </div>
    </div>
  )
}

export default ScoreRing
